/**
 * This JS takes a screenshot of a portion of the page, which can then be shared with Instagram using iOS/Android's native share function
 * 
 * Should only be used on iOS/Android
 * 
 * We use a dynamic import using `await import` - this means ModernScreenshot is loaded from an external file rather than bundled with our JS
 * 
 * Before taking the screenshot, any images within the element are updated to use absolute URLs instead of relative URLs
 */

export default class DomScreenshot {
	constructor() {
		this.loadVendor();
	}

	async loadVendor() {
		console.log("DomScreenshot.loadVendor");

		// Webpack fails to import properly unless we specify the filename :/
		const { domToPng } = await import('Vendor/modern-screenshot/dist/index.mjs');
		console.log("DomScreenshot.loadVendor", "ModernScreenshot.domToPng loaded");

		this.domToPng = domToPng;
	}

	async screenshotElement(element) {
		console.log("DomScreenshot.screenshotElement");

		if(!this.domToPng) {
			throw new Error("ModernScreenshot not loaded");
		}

		// If it's $(element) then get the DOM element
		element = element[0] || element;

		if (!element || !(element instanceof Element)) {
			throw new Error('No valid DOM element provided');
		}

		this.cleanChildImageUrls(element);

		// The screenshot method sometimes doesn't see images in time, so delay it
		await new Promise(r => setTimeout(r, 1000));

		return await this.domToPng(element, {
			scale: 4, // This improved the quality
		});
	}

	cleanChildImageUrls(element) {
		element.querySelectorAll('img, picture source').forEach(img => {
			// Covers both <img src=""> and <source srcset="">
			let imgUrl = img.getAttribute("src") || img.getAttribute("srcset");
			const isSourceElement = img.tagName == "SOURCE";

			// Check if external SVG - can't screenshot them, so delete from <picture>
			if (isSourceElement && img.getAttribute('srcset')?.includes(".svg")) {
				img.remove();
				return;
			}

			const location = window.location;

			// Check if image source is already absolute
			if (imgUrl.startsWith(location.origin)) {
				return;
			}

			imgUrl = new URL(imgUrl, location.href).href;

			if (isSourceElement) {
				img.srcset = imgUrl;
			} else {
				img.src = imgUrl;
			}
		});
	}
}